import { render, staticRenderFns } from "./viewLaboratoryAnalaysis.vue?vue&type=template&id=1794ac04&"
import script from "./viewLaboratoryAnalaysis.vue?vue&type=script&lang=js&"
export * from "./viewLaboratoryAnalaysis.vue?vue&type=script&lang=js&"
import style0 from "./viewLaboratoryAnalaysis.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports